export const DEFAULT_PAYMENTS_NAMESPACE = 'weave-location';

export type PaymentsNamespace = 'weave-location' | 'payments';
